import { Controller } from "stimulus"

class FloatingFooterController extends Controller {
  static targets = ["footer", "scrollBoundary"]
  static classes = ["show"]
  static values = { 
    threshold: Number,
    hideOffset: Number
  }

  connect() {
    this.isVisible = false
    this.observer = null
    this.threshold = this.hasThresholdValue ? this.thresholdValue : 0.3
    this.hideOffset = this.hasHideOffsetValue ? this.hideOffsetValue : 100
    this.setupObserver()
    this.bindScrollEvent()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
    window.removeEventListener('scroll', this.handleScroll)
  }

  setupObserver() {
    if (!this.hasScrollBoundaryTarget) {
      return
    }

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0  // sticky_headerと同じ値に設定
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // sticky_headerと同じロジック：要素が画面外になったら表示
        if (!entry.isIntersecting) {
          this.showFooter()
        } else {
          this.hideFooter()
        }
      })
    }, options)

    this.observer.observe(this.scrollBoundaryTarget)
  }

  showFooter() {
    if (this.isVisible) return

    this.footerTarget.classList.add(this.showClass)
    this.isVisible = true
  }

  hideFooter() {
    if (!this.isVisible) return

    this.footerTarget.classList.remove(this.showClass)
    this.isVisible = false
  }

  bindScrollEvent() {
    this.handleScroll = this.handleScroll.bind(this)
    window.addEventListener('scroll', this.handleScroll)
  }

  handleScroll() {
    // scrollBoundary要素の位置チェック（sticky_headerと同じロジック）
    if (this.hasScrollBoundaryTarget) {
      const rect = this.scrollBoundaryTarget.getBoundingClientRect()
      
      // トリガー要素が完全に画面外に出たら表示
      if (rect.bottom < 0 || rect.top > window.innerHeight) {
        if (!this.isVisible) {
          this.showFooter()
        }
      }
      // トリガー要素が画面内にあれば非表示
      else {
        if (this.isVisible) {
          this.hideFooter()
        }
      }
    }
  }
}

// StimulusJSに登録
window.Stimulus.register('site--company--sp--floating-footer', FloatingFooterController)

export default FloatingFooterController
